export default "__VITE_ASSET__DIfN_7J8__"